import faker from 'faker';

export default Array(10)
  .fill(0)
  .map((_, index) => ({
    id: index,
    nome: faker.lorem.words(1),
    sigla: faker.lorem.words(1),
    responsavel: faker.lorem.words(1),
    descricao: faker.lorem.sentence(20),
  }));
